import { Routes } from '@angular/router';

// layouts
import { AppLayout } from './layouts/app-layout';
import { AuthLayout } from './layouts/auth-layout';
import { PublicGuard } from './core/guards/public.guard';
import { ProtectedGuard } from './core/guards/protected.guard';
import { appInitializationGuard } from './core/guards/app-initialization.guard';

export const routes: Routes = [
    // Auth routes
    {
        path: 'login',
        component: AuthLayout,
        canActivate: [PublicGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./modules/auth/sign-in/sign-in.component').then((c) => c.SignInComponent),
                data: { title: 'Login' }
            }
        ]
    },
    {
        path: 'register',
        component: AuthLayout,
        canActivate: [PublicGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./modules/auth/sign-up/sign-up').then((c) => c.SignUpComponent),
                data: { title: 'Register' }
            }
        ]
    },
    {
        path: 'forgot-password',
        component: AuthLayout,
        canActivate: [PublicGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./modules/auth/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent),
                data: { title: 'Forgot Password' }
            }
        ]
    },
    {
        path: 'mfa',
        component: AuthLayout,
        canActivate: [PublicGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./modules/auth/mfa/mfa.component').then((c) => c.MfaComponent),
                data: { title: 'MFA' }
            }
        ]
    },
    {
        path: 'reset-password',
        component: AuthLayout,
        canActivate: [PublicGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./modules/auth/reset-password/reset-password.component').then((c) => c.ResetPasswordComponent),
                data: { title: 'Reset Password' }
            }
        ]
    },

    {
        path: 'verify-email',
        component: AuthLayout,
        canActivate: [PublicGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('./modules/auth/verify-email/verify-email.component').then((c) => c.VerifyEmailComponent),
                data: { title: 'Verify Email' }
            },
                        {
                path: 'verify',
                loadComponent: () => import('./modules/auth/verification-result.component/verification-result.component').then((c) => c.VerificationResultComponent),
                data: { title: 'Verify' }
            },
            {
                path: 'success',
                loadComponent: () => import('./modules/auth/verification-result.component/verification-result.component').then((c) => c.VerificationResultComponent),
                data: { title: 'Verify Email' }
            },
             {
                path: 'failed',
                loadComponent: () => import('./modules/auth/verification-result.component/verification-result.component').then((c) => c.VerificationResultComponent),
                data: { title: 'Verify Email' }
            }
        ]
    },

    // Protected routes - default route for authenticated users
    {
        path: '',
        component: AppLayout,
        canActivate: [ProtectedGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./modules/protected/protected-routing.module').then((m) => m.ProtectedRoutingModule),
            },
        ],
    },
    {
        path: '',
        redirectTo: 'onboarding',
        pathMatch: 'full',
    },
    {
        path: "onboarding",
        canActivate: [ProtectedGuard, appInitializationGuard],
        loadChildren: () => import('./modules/onboarding/onboarding-routing-module').then((m) => m.OnboardingRoutingModule),


    },
    { path: '**', redirectTo: '/login' },
];
